import { css } from 'styled-components'

export default css`
  .BaseModal-Content.popup {
    width: 520px;
  }

  &.VerifyEmailModal .BaseModal-Body {
    position: relative;
    overflow: hidden;
    padding: 60px;
  }

  .verify-email-decorative-image {
    position: absolute;
    top: 0;
    right: 0;
    pointer-events: none;
  }

  .verify-email-form {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .verify-email-title {
    font-size: 32px;
    line-height: 36px;
    font-family: 'Rubik-Regular', sans-serif;
  }

  .verify-email-subtitle {
    font-size: 16px;
    line-height: 20px;

    .bold-email {
      font-family: 'Rubik-Medium', sans-serif;
    }
  }

  .verify-email-wrong-email {
    font-size: 14px;
    line-height: 18px;
  }

  .verify-email-actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }

  .verify-email-feedback {
    text-align: center;
  }
`
